import * as Validation from "./valid-input";

export const loadInitialPage = (questionnaire, pages, answers, questionsVisibility) => {
  if (Object.keys(answers).length === 0) {
    return 1;
  }

  for (const page in pages) {
    const dimensionNumbers = pages[page];
    const validInput = Validation.getValidInput(questionnaire, answers, dimensionNumbers);
    if (!Validation.isAllInputValid(validInput, questionsVisibility)) {
      return parseInt(page);
    }
  }

  return Object.keys(pages).length;
};
